import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Own actions/services/reducers
import { carouselReducer } from 'services/reducers/carousel';
import { filterSectionReducer } from 'services/reducers/filters';
import { reviveReducer } from 'services/reducers/revive';
import { carouselFooterReducer } from 'services/reducers/carousel-footer';
import { detailExperienceReducer } from 'services/reducers/detail-experience';
import { detailExperienceReviveReducer } from 'services/reducers/detail-inspire';
import { addItemsShoppingCartReducer } from 'services/reducers/shopping-cart';
import { personalDataReducer } from 'services/reducers/personal-data';
import { postalCodeDataReducer } from 'services/reducers/postal-code';
import { postSubmitShoppingReducer } from 'services/reducers/submit-shopping';
import { sessionReducer } from 'services/reducers/header';
import { exclusivityBannerReducer } from 'services/reducers/exclusivity-banner';
import { experienciesExclusivitiesToRemoveReducer } from 'services/reducers/exclusivity-experience';

const rootReducer = combineReducers({
  carouselReducer,
  filterSectionReducer,
  reviveReducer,
  carouselFooterReducer,
  detailExperienceReducer,
  detailExperienceReviveReducer,
  addItemsShoppingCartReducer,
  personalDataReducer,
  postalCodeDataReducer,
  postSubmitShoppingReducer,
  sessionReducer,
  exclusivityBannerReducer,
  experienciesExclusivitiesToRemoveReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'carouselReducer',
    'filterSectionReducer',
    'reviveReducer',
    'carouselFooterReducer',
    'addItemsShoppingCartReducer',
  ],
};

export default persistReducer(persistConfig, rootReducer);
